var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ato-button",class:[
    _vm.buttonSize ? 'ato-button--' + _vm.buttonSize : '',
    { 'is-border': _vm.border },
    { 'is-disabled': _vm.disabled }
  ],attrs:{"disabled":_vm.disabled}},[(_vm.$slots.default)?_c('strong',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }